import { app, each, ojs } from "modular-openscriptjs";
import OrderDetailProductView from "../Views/OrderDetailProductView";

const h = app("h");
ojs(OrderDetailProductView)

export default function OrderedItems(items, order, ...args) {
	return h.div(
		{
			id: `c-order-products-${order?.id}-holder`,
			class: "d-flex flex-column gap-3 pb-3",
		},
		each((items || []), (item) => {
			return h.OrderDetailProductView(item.version_buyable || item.buyable || item.product, item, order, {
				class: "bg-white rounded-4 shadow-sm p-3 related-product border-0 w-100",
			});
		}),
		...args
	);
}